import LinkBlockIcon from "../../../images/default_link_block_new_icon.svg";
import ButtonBlockIcon from "../../../images/default_button_block_new_icon.svg";
import "./customLinkBlock.scss";

export const customLinkBlock = (editor) => {
//   editor.Blocks.add("Button", {
//     category: "extra",
//     label: "Button",

//     media: `<img src="${ButtonBlockIcon}" class="button-block" title="Button" alt="button" draggable="false"/>`,
//     id: "button",
//     // media: `<img src="${TableIcon}" alt="table" />`,
//     content: { type: "button" },
//     activate: false,
//      content: {
//         type: "link",
//         content: "Click Me !",

//         attributes: {
//           // href: "https://www.google.com",
//           alt: "link",
//           contenteditable: true,
//         },
//         traits: [
//           {
//             type: "text",
//             name: "Title",
//             label: "Title",
//             placeholder: "Enter title",
//           },
//           {
//             type: "href",
//             name: "href",
//             label: "URL",
//             changeProp: true,
//           },
//           {
//             type: "select",
//             name: "target",
//             label: "Target",
//             default: "_self",
//             changeProp: true,
//             options: [
//               // Here the key is the `id` of the option
//               { id: "_self", label: "This window", value: "_self" },
//               { id: "_blank", label: "New window", value: "_blank" },
//             ],
//           },
//         ],

//         unstylable: ["transform", "transition", "perspective"],
//         style: {
//           // width: "54px",
//           // height: "32px",
//           padding: "8px 28px",
//           //border: "solid 1px #203662",
//           "background-color": "#203662",
//           "font-size": "12px",
//           "font-weight": "bold",
//           "letter-spacing": "0.1px",
//           "text-align": "center",
//           color: "#fff",
//           cursor: "pointer",
//           display: "inline-block",
//           "text-decoration": "none",
//           "font-family": "Nunito Sans",
//           outline: "none",
//         },
//       },
// });

  editor.Blocks.add("Button", {
  category: "extra",
  label: "Button",
  media: `<img src="${ButtonBlockIcon}" class="button-block" title="Button" alt="button" draggable="false"/>`,
  id: "button",
  // content: {
  //   type: "link", // custom component
  //   content: "Click Me!",
  //   attributes: {
  //     alt: "link",
  //   },
  //   style: {
  //     padding: "8px 28px",
  //     "background-color": "#203662",
  //     "font-size": "12px",
  //     "font-weight": "bold",
  //     "letter-spacing": "0.1px",
  //     "text-align": "center",
  //     color: "#fff",
  //     cursor: "pointer",
  //     display: "inline-block",
  //     "text-decoration": "none",
  //     "font-family": "Nunito Sans",
  //     outline: "none",
  //   },
  // },
  content: {
        type: "link",
        content: "Click Me !",

        attributes: {
          // href: "https://www.google.com",
          alt: "link",
          // contenteditable: true,
        },
        traits: [
          {
            type: "text",
            name: "Title",
            label: "Title",
            placeholder: "Enter title",
          },
          {
            type: "href",
            name: "href",
            label: "URL",
            changeProp: true,
          },
          {
            type: "select",
            name: "target",
            label: "Target",
            default: "_self",
            changeProp: true,
            options: [
              // Here the key is the `id` of the option
              { id: "_self", label: "This window", value: "_self" },
              { id: "_blank", label: "New window", value: "_blank" },
            ],
          },
        ],

        unstylable: ["transform", "transition", "perspective"],
        style: {
          // width: "54px",
          // height: "32px",
          padding: "8px 28px",
          //border: "solid 1px #203662",
          "background-color": "#203662",
          "font-size": "12px",
          "font-weight": "bold",
          "letter-spacing": "0.1px",
          "text-align": "center",
          color: "#fff",
          cursor: "pointer",
          display: "inline-block",
          "text-decoration": "none",
          "font-family": "Nunito Sans",
          outline: "none",
        },
      },
});

  editor.Blocks.add("content-link", {
    label: "Link Block",
    category: "extra",
    media: `<img src="${LinkBlockIcon}" class="extra-link-block" title="Link Block" draggable="true" />`,
    content: {
      type: "link",
      label: "Link Block",
      name: "Link Block",
    },
  });

  editor.Components.addType("link", {
  extend: "link",
  // model: {
  //   defaults: {
  //     tagName: "a",
  //     editable: true,
  //     droppable: false,
  //     attributes: {
  //       // href: "#",
  //       href: "http://google.com",
  //       title: "Button Link",
  //     },
  //     traits: [
  //       {
  //         type: "text",
  //         name: "title",
  //         label: "Title",
  //         placeholder: "Enter title",
  //       },
  //       {
  //         type: "href",
  //         name: "href",
  //         label: "URL",
  //         changeProp: true,
  //       },
  //       {
  //         type: "select",
  //         name: "target",
  //         label: "Target",
  //         default: "_self",
  //         options: [
  //           { id: "_self", label: "This window", value: "_self" },
  //           { id: "_blank", label: "New window", value: "_blank" },
  //         ],
  //       },
  //     ],
  //     // ensure it behaves like editable inline text
  //     content: "Click Me!",
  //     style: {
  //       display: "inline-block",
  //       padding: "8px 28px",
  //       "background-color": "#203662",
  //       "font-size": "12px",
  //       "font-weight": "bold",
  //       "letter-spacing": "0.1px",
  //       "text-align": "center",
  //       color: "#fff",
  //       cursor: "pointer",
  //       "text-decoration": "none",
  //       "font-family": "Nunito Sans",
  //       outline: "none",
  //     },
  //   },
  // },
   model: {
      defaults: {
        traits: [
          {
            type: "text",
            name: "Title",
            label: "Title",
            placeholder: "Enter title",
          },
          {
            type: "href",
            name: "href",
            label: "URL",
            changeProp: true,
          },
          {
            type: "select",
            name: "target",
            label: "Target",
            default: "_self",
            options: [
              // Here the key is the `id` of the option
              { id: "_self", label: "This window", value: "_self" },
              { id: "_blank", label: "New window", value: "_blank" },
            ],
          },
          // <select><option value="false">This window</option><option value="_blank">New window</option></select>
        ],

        editable: true,
        droppable: `[data-gjs-type="form"],
       [data-gjs-type="default"],
       [data-gjs-type="Div"],
       [data-gjs-type="text"],
       [data-gjs-type="image"],
       [data-gjs-type="table"],
       [data-gjs-type="tabs"],
       [data-gjs-type="textarea"],
       [data-gjs-type="video"],
       [data-gjs-type="hr"],
       [data-gjs-type="input"],
       [data-gjs-type="select"],
       [data-gjs-type="button"],
       [data-gjs-type="label"],
       [data-gjs-type="checkbox"],
       [data-gjs-type="radio"]
       `,

        style: {
          display: "inline-block",
          padding: "5px",
          "min-height": "50px",
          "min-width": "50px",
        },
        attributes: { href: "http://google.com" },
      },
    },
});
  // editor.Components.addType("link", {
  //   extend: "link",
  //   model: {
  //     defaults: {
  //       traits: [
  //         {
  //           type: "text",
  //           name: "Title",
  //           label: "Title",
  //           placeholder: "Enter title",
  //         },
  //         {
  //           type: "href",
  //           name: "href",
  //           label: "URL",
  //           changeProp: true,
  //         },
  //         {
  //           type: "select",
  //           name: "target",
  //           label: "Target",
  //           default: "_self",
  //           options: [
  //             // Here the key is the `id` of the option
  //             { id: "_self", label: "This window", value: "_self" },
  //             { id: "_blank", label: "New window", value: "_blank" },
  //           ],
  //         },
  //         // <select><option value="false">This window</option><option value="_blank">New window</option></select>
  //       ],

  //       editable: true,
  //       droppable: `[data-gjs-type="form"],
  //      [data-gjs-type="default"],
  //      [data-gjs-type="Div"],
  //      [data-gjs-type="text"],
  //      [data-gjs-type="image"],
  //      [data-gjs-type="table"],
  //      [data-gjs-type="tabs"],
  //      [data-gjs-type="textarea"],
  //      [data-gjs-type="video"],
  //      [data-gjs-type="hr"],
  //      [data-gjs-type="input"],
  //      [data-gjs-type="select"],
  //      [data-gjs-type="button"],
  //      [data-gjs-type="label"],
  //      [data-gjs-type="checkbox"],
  //      [data-gjs-type="radio"]
  //      `,

  //       style: {
  //         display: "inline-block",
  //         padding: "5px",
  //         "min-height": "50px",
  //         "min-width": "50px",
  //       },
  //       attributes: { href: "http://google.com" },
  //     },
  //   },
  // });
};
